// Gravity Forms Post Render 
jQuery(document).bind('gform_post_render', function(event, form_id, current_page) {

    var mediacodeQSP = getParameterByName('mediacode');

    var mediacodeCookie = Cookies.get('mediacode');

    var emailQSP = getParameterByName('email');

    var cmsCookie = Cookies.get('CmsCookie');

    var basVendorQSP = getParameterByName('bas_vendor');

    if (cmsCookie) {
        parsedCmsCookie = JSON.parse(cmsCookie);
    }
 	
 	// Gravity Form 1, the IUSA Registration form
	if (form_id === 1 || form_id === 5) {    	

    	if (mediacodeQSP) {

            jQuery('#input_1_30').val(mediacodeQSP);
            jQuery('#input_5_30').val(mediacodeQSP);

        } else if (mediacodeCookie) {

            jQuery('#input_1_30').val(mediacodeCookie);
            jQuery('#input_5_30').val(mediacodeCookie);

        }

        // set detected device type to hidden field
        jQuery('#input_1_27').val(detectedDevice);
        jQuery('#input_5_27').val(detectedDevice);

	}

    // Gravity Form 2, the Web to Lead | Contact Us form
    else if (form_id === 2) {

        if (mediacodeQSP) {

            jQuery('#input_2_13').val(mediacodeQSP);

        } else if (mediacodeCookie) {

            jQuery('#input_2_13').val(mediacodeCookie);

        }       

    }

    // Gravity Form 4, the IUSA App Login API form
    else if (form_id === 4) {

        if (basVendorQSP) {

            jQuery('#input_4_3').val(basVendorQSP);

        } else if (basVendorCookie) {

            jQuery('#input_4_3').val(basVendorCookie);

        }  

    }

 
});

jQuery(document).ready(function() {

    // add Foundation 6 Reveal modal open attribute to elements having the modal-w2l-form class
    jQuery('.modal-w2l-form').attr('data-open', 'footer-w2l-modal').click(function(event) {
        event.preventDefault();
    });

    // add Foundation 6 Reveal modal open attribute to elements having the modal-registration-form class
    jQuery('.modalRegistration').attr('data-open', 'footer-registration-modal').click(function(event) {
        event.preventDefault();
    });
    
});